import * as React from 'react';

import { Tab } from './Tab';
import { ITabsProps } from './types';

import * as styles from './styles.css';

export const Tabs: React.FC<ITabsProps> = props => {
  const { activeIDs, items } = props;

  return (
    <div className={styles['container']}>
      {items.map(tab => {
        return <Tab key={tab.id} {...tab} isActive={activeIDs && activeIDs.includes(tab.id)} onClick={props.onClick} />;
      })}
    </div>
  );
};

Tabs.displayName = 'Tabs';
